import React, { Component } from "react";
import axios from "axios";

class Gallery extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idx: props.match.params.idx,
      galleryimagelist: [],
    };
  }

  componentDidMount() {
    this.getImages();
  }

  getImages() {
    axios
      .post("https://happyqr.net/api/starname/api/getGalleryImages", {
        idx: this.state.idx,
      })
      .then((data) => {
        console.log(data.data);
        if (data.data.code == 200) {
          this.setState({
            galleryimagelist: data.data.images,
          });
        }
      })
      .catch((error) => {
        console.log("error : ", error);
      });
  }

  renderHeader() {
    return (
      <img
        src={"/rc_logo_white.png"}
        style={{ paddingTop: "2%", height: "75%" }}
      ></img>
    );
  }

  render() {
    var settings = {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
    };

    return (
      <div className="app">
        <div className="main">
          {this.state.galleryimagelist.map((item, index) => {
            return (
              <img
                style={{ width: "100%", marginTop: 10 }}
                src={item.fullpath}
              />
            );
          })}
        </div>
      </div>
    );
  }
}

export default Gallery;
